// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__10i6m","requiredAsterisk":"Info_requiredAsterisk__2U6M6"};